module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/signin-d8ce1d2529b24761de792aa06910c757.jpg";